import { t as uiText } from '../../i18n';
export function normalizeSiteOrigin(input: string): string {
  const trimmed = input.trim();
  if (!trimmed) {
    throw new Error(uiText("Enter the host site URL"));
  }
  const withProtocol = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
  let url: URL;
  try {
    url = new URL(withProtocol);
  } catch {
    throw new Error(uiText("Invalid URL format. Example: https://example.com"));
  }
  if (url.protocol !== 'http:' && url.protocol !== 'https:') {
    throw new Error(uiText("Protocol must be http or https"));
  }
  return `${url.protocol}//${url.host}`;
}

export function findReadyEmbedToken<T extends { isActive: boolean; allowedOrigins: string[] }>(
  tokens: T[],
): T | null {
  return tokens.find((token) => token.isActive && token.allowedOrigins.length > 0) ?? null;
}
